'use strict';

var base = require('core/storeLocator/storeLocator');
var mapStyle = require('./mapStyles').mapStyle;

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
  var newUrl = url;
  newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
    return key + '=' + encodeURIComponent(params[key]);
  }).join('&');
  return newUrl;
}

/**
 * Uses google maps api to render a map
 */
function maps() {
  var map;
  var infowindow = new google.maps.InfoWindow();

  // Init U.S. Map in the center of the viewport
  var latlng = new google.maps.LatLng(37.09024, -95.712891);
  var mapOptions = {
    scrollwheel: false,
    zoom: 4,
    center: latlng,
    disableDefaultUI: true,
    styles: mapStyle
  };
  function getMiles(meters) {
    return (meters * 0.000621371192).toFixed(1);
  }
  var $mapCanvas = $('.map-canvas');
  map = new google.maps.Map($('.map-canvas')[0], mapOptions);
  var mapdiv = $mapCanvas.attr('data-locations');
  mapdiv = JSON.parse(mapdiv);
  var bounds = new google.maps.LatLngBounds();
  var fillColor = getBackgroundColor();

  // Customized google map marker icon with svg format
  var markerImg = {
    path: google.maps.SymbolPath.CIRCLE,
    scale: 15,
    fillColor: fillColor,
    fillOpacity: 1,
    strokeWeight: 0
  };
  var storeCounter = 1;
  // storeType is an array of store types
  var storeTypes = $mapCanvas.attr('data-store-type');
  // convert storeType to an array
  storeTypes = storeTypes.split(',');
  var locations = [];
  if (mapdiv) {
    Object.keys(mapdiv).forEach(function (key) {
      var item = mapdiv[key];

      // iterate througth storeTypes array
      storeTypes.forEach(function (storeType) {
        if (item.type === storeType) {
          var searchedLocationData = JSON.parse($mapCanvas.attr('data-searched-location'));
          var searchedLocation = new google.maps.LatLng(searchedLocationData.lat, searchedLocationData["long"]);
          var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
          var storeDistance = getMiles(google.maps.geometry.spherical.computeDistanceBetween(searchedLocation, storeLocation));
          // add distance
          item.distance = parseFloat(storeDistance);
          locations.push(item);
        }
      });
    });
    locations.sort(function (a, b) {
      return a.distance - b.distance;
    });
    locations.forEach(function (item) {
      // iterate througth storeTypes array
      storeTypes.forEach(function (storeType) {
        if (item.type === storeType) {
          var label = storeCounter++;
          var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
          var marker = new google.maps.Marker({
            position: storeLocation,
            map: map,
            title: item.accountName,
            icon: markerImg,
            label: {
              text: label.toString(),
              color: 'white',
              fontSize: '16px'
            },
            distributorID: item.distributorID
          });
          var infoWindowHtml = '<div class="info-window-content">';
          infoWindowHtml += '<div class="info-title">' + item.accountName + '</div>';
          infoWindowHtml += '<div class="info-address">';
          infoWindowHtml += '<div>' + item.street + '</div>';
          infoWindowHtml += '<div>' + item.city + ', ' + item.state + '</div>';
          infoWindowHtml += '<div>' + item.postalCode + '</div>';
          infoWindowHtml += '</div>';
          infoWindowHtml += '<div class="info-contact">';
          infoWindowHtml += '<div class="distance"><span class="icon icon-map-pin"></span>' + item.distance + ' mi</div>';
          // if phone in item exists, add phone to info window
          if (item.phone) {
            infoWindowHtml += '<div class="phone"><span class="icon icon-headset"></span>' + item.phone + '</div>';
          }
          infoWindowHtml += '</div>';
          infoWindowHtml += '</div>';
          var $locationCardTemplate = $('#location-card-template').clone();
          $locationCardTemplate.addClass(item.distributorID);
          $locationCardTemplate.find('.circle').text(label);
          $locationCardTemplate.find('.location-title').text(item.accountName);
          $locationCardTemplate.find('.location-distance').text(item.distance + ' mi');
          $locationCardTemplate.find('.location-address .street').text(item.street);
          $locationCardTemplate.find('.location-address .city').text(item.city);
          $locationCardTemplate.find('.location-address .state').text(item.state);
          $locationCardTemplate.find('.location-address .postalCode').text(item.postalCode);
          if (item.preferredStatus === false) {
            $locationCardTemplate.find('.preferred').text('');
          }
          if (item.callUrl) {
            $locationCardTemplate.find('.location-links .callLink').attr('href', item.callUrl);
          } else {
            $locationCardTemplate.find('.location-links .callLink').hide();
          }
          $locationCardTemplate.find('.location-links .directionsLink').attr('href', item.directionsUrl);
          var locationHtml = $locationCardTemplate.html();
          $locationCardTemplate.remove();
          var $locationCardHtml = $('<div class="card location" data-distributor-id="' + item.distributorID + '">' + locationHtml + '</div>');
          $('.location-list').append($locationCardHtml);
          var selectLocationCard = function selectLocationCard() {
            $('.location-list .location').removeClass('selected');
            $locationCardHtml.addClass('selected');
          };
          var openInfoWindow = function openInfoWindow() {
            infowindow.setOptions({
              content: infoWindowHtml
            });
            infowindow.open(map, marker);
            selectLocationCard();
          };
          $locationCardHtml.on('mouseover', openInfoWindow);
          marker.addListener('mouseover', openInfoWindow);

          // Create a minimum bound based on a set of storeLocations
          bounds.extend(marker.position);
        }
      });
    });

    // Don't zoom in too far on only one marker
    var boundsPadding = 0.01;
    if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
      var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + boundsPadding, bounds.getNorthEast().lng() + boundsPadding);
      var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - boundsPadding, bounds.getNorthEast().lng() - boundsPadding);
      bounds.extend(extendPoint1);
      bounds.extend(extendPoint2);
    }

    // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    if (mapdiv && mapdiv.length !== 0) {
      map.fitBounds(bounds);
    }

    // hide messaging if no locations are found
    $('.location-list .no-locations-error').hide();
  } else {
    // display messaging if no locations are found
    $('.location-list .no-locations-error').show();
  }

  // Remove template card
  $('#location-card-template').remove();
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
  var $resultsDiv = $('.results');
  var $mapDiv = $('.map-canvas');
  var hasResults = data.stores.length > 0;
  if (!hasResults) {
    $('.store-locator-no-results').show();
    $('.filter-results').hide();
    $resultsDiv.attr('data-has-results', false);
  } else {
    $('.store-locator-no-results').hide();
    $('.filter-results').show();
    $resultsDiv.attr('data-has-results', true);
  }
  $resultsDiv.empty().data('has-results', hasResults).data('radius', data.radius).data('search-key', data.searchKey).data('store-type', data.storeType);
  $mapDiv.attr('data-locations', data.locations);
  if ($mapDiv.data('has-google-api')) {
    module.exports.methods.maps();
  } else {
    $('.store-locator-no-apiKey').show();
  }
  if (data.storesResultsHtml) {
    $resultsDiv.append(data.storesResultsHtml);
  }
  if (data.noInventoryStoresHtml) {
    $resultsDiv.append(data.noInventoryStoresHtml);
  }
  if (hasResults) {
    $.each(data.storeTypes, function (storeType) {
      var storeTypeValue = data.storeTypes[storeType].value || data.storeTypes[storeType].value;
      if ($('.results [data-store-type="' + storeTypeValue + '"]').length > 0) {
        $('.filter-results [data-filter="' + storeTypeValue + '"]').show();
      }
    });
  }
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
function search(element) {
  var dialog = element.closest('.in-store-inventory-dialog');
  var spinner = dialog.length ? dialog.spinner() : $.spinner();
  spinner.start();
  var $form = element.closest('.store-locator');
  var radius = $('.results').data('radius');
  var url = $form.attr('action');
  var urlParams = {
    radius: radius
  };
  var payload = $form.is('form') ? $form.serialize() : {
    postalCode: $form.find('[name="postalCode"]').val()
  };
  var cleanPayload = decodeURI(payload).replace(/\s/g, '');
  url = appendToUrl(url, urlParams);
  $.ajax({
    url: url,
    type: $form.attr('method'),
    data: cleanPayload,
    dataType: 'json',
    success: function success(data) {
      updateStoresResults(data);
      $('.select-store').prop('disabled', true);
    },
    complete: function complete() {
      spinner.stop();
    }
  });
  return false;
}
function hex(x) {
  return ('0' + parseInt(x).toString(16)).slice(-2);
}
function getBackgroundColor() {
  try {
    // GET THE BACKGROUND COLOR OF $('.card-body .circle')
    var circleColor = $('.card-body .circle').css('background-color');
    // IF CIRCLECOLOR MATCHES RGB, RETURN ARRAY OF RGB VALUES
    circleColor = circleColor.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    // RETURN DEFAULT COLOR IF CIRCLECOLOR IS TRANSPARENT OR NOT RGB
    if (!circleColor || circleColor === 'transparent') {
      return '#B02125';
    }
    // CONVERT CIRCLECOLOR TO HEX
    circleColor = '#' + hex(circleColor[1]) + hex(circleColor[2]) + hex(circleColor[3]);
    return circleColor;
  } catch (e) {
    return '#B02125';
  }
}
module.exports = {
  methods: {
    maps: maps,
    search: search,
    updateStoresResults: updateStoresResults
  },
  init: function init() {
    if ($('.map-canvas').data('has-google-api')) {
      module.exports.methods.maps();
    } else {
      $('.store-locator-no-apiKey').show();
    }
  },
  detectLocation: function detectLocation() {
    // clicking on detect location.
    $('.detect-location').on('click', function () {
      $.spinner().start();
      if (!navigator.geolocation) {
        $.spinner().stop();
        return;
      }
      navigator.geolocation.getCurrentPosition(function (position) {
        var $detectLocationButton = $('.detect-location');
        var url = $detectLocationButton.data('action');
        var radius = $('.results').data('radius');
        var urlParams = {
          radius: radius,
          lat: position.coords.latitude,
          "long": position.coords.longitude
        };
        url = appendToUrl(url, urlParams);
        $.ajax({
          url: url,
          type: 'get',
          dataType: 'json',
          success: function success(data) {
            $.spinner().stop();
            module.exports.methods.updateStoresResults(data);
            $('.select-store').prop('disabled', true);
            $('.detect-location-invalid').removeClass('d-block');
          }
        }).fail(function () {
          $.spinner().stop();
        });
      }, function () {
        $.spinner().stop();
        $('.detect-location-invalid').addClass('d-block');
      }, {
        timeout: 5000
      });
    });
  },
  search: function search() {
    $('.store-locator-container form.store-locator').submit(function (e) {
      e.preventDefault();
      module.exports.methods.search($(this));
    });
    $('.store-locator-container .btn-storelocator-search[type="button"]').click(function (e) {
      e.preventDefault();
      module.exports.methods.search($(this));
    });
  },
  changeRadius: function changeRadius() {
    $('.store-locator-container .radius').change(function () {
      var radius = $(this).val();
      var searchKeys = $('.results').data('search-key');
      var url = $(this).data('action-url');
      var urlParams = {};
      if (searchKeys.postalCode) {
        urlParams = {
          radius: radius,
          postalCode: searchKeys.postalCode
        };
      } else if (searchKeys.lat && searchKeys["long"]) {
        urlParams = {
          radius: radius,
          lat: searchKeys.lat,
          "long": searchKeys["long"]
        };
      }
      $('.filter-results [data-filter]').removeClass('active btn-primary').addClass('btn-secondary').hide();
      $('.filter-results [data-filter="all"]').addClass('active btn-primary').removeClass('btn-secondary').show();
      url = appendToUrl(url, urlParams);
      var dialog = $(this).closest('.in-store-inventory-dialog');
      var spinner = dialog.length ? dialog.spinner() : $.spinner();
      spinner.start();
      $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function success(data) {
          module.exports.methods.updateStoresResults(data);
          $('.select-store').prop('disabled', true);
        },
        complete: function complete() {
          spinner.stop();
        }
      });
    });
  },
  filterResults: function filterResults() {
    var $filters = $('.filter-results [data-filter]');
    $filters.on('click', function (e) {
      e.preventDefault();
      $filters.removeClass('active btn-primary').addClass('btn-secondary');
      $(this).addClass('active btn-primary').removeClass('btn-secondary');
      var $filterType = $(this).attr('data-filter');
      var radius = $('.results').data('radius');
      var searchKeys = $('.results').data('search-key');
      var url = $('.store-locator-container .filter-results').data('action-url');
      var urlParams = {};
      if (searchKeys.postalCode) {
        urlParams = {
          radius: radius,
          postalCode: searchKeys.postalCode,
          storeType: $filterType
        };
      } else if (searchKeys.lat && searchKeys["long"]) {
        urlParams = {
          radius: radius,
          lat: searchKeys.lat,
          "long": searchKeys["long"],
          storeType: $filterType
        };
      }
      url = appendToUrl(url, urlParams);
      var dialog = $('.store-locator-container .radius').closest('.in-store-inventory-dialog');
      var spinner = dialog.length ? dialog.spinner() : $.spinner();
      spinner.start();
      $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function success(data) {
          module.exports.methods.updateStoresResults(data);
          $('.select-store').prop('disabled', true);
        },
        complete: function complete() {
          spinner.stop();
        }
      });
    });
  }
};
Object.keys(base).forEach(function (prop) {
  // eslint-disable-next-line no-prototype-builtins
  if (!module.exports.hasOwnProperty(prop)) {
    module.exports[prop] = base[prop];
  }
});